var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313840",
    fillRule: "nonzero",
    d: "M24.556 3.358a.493.493 0 0 0-.693 0L7.254 20.689a.548.548 0 0 0 0 .722l5.19 5.416c.182.19.511.19.693 0L29.746 9.496a.548.548 0 0 0 0-.722l-5.19-5.416zm-2.423 3.25l2.423 2.527c.19.2.5.2.692 0a.526.526 0 0 0 0-.722l-2.423-2.528 1.385-1.444 4.498 4.694-15.918 16.61-4.498-4.695 1.384-1.444 2.422 2.527c.192.2.501.2.692 0a.526.526 0 0 0 0-.722l-2.422-2.527 1.384-1.445 1.385 1.445c.19.2.5.2.692 0a.526.526 0 0 0 0-.722l-1.385-1.445 1.385-1.444 1.384 1.444c.19.2.5.2.692 0a.526.526 0 0 0 0-.722l-1.384-1.444 7.612-7.944zm-6.228 6.499l2.422 2.527c.191.2.5.2.692 0a.526.526 0 0 0 0-.722l-2.422-2.528 1.384-1.444 1.384 1.444c.191.2.501.2.692 0a.526.526 0 0 0 0-.722l-1.384-1.444 1.384-1.444 1.384 1.444c.191.2.501.2.692 0a.526.526 0 0 0 0-.722L20.75 8.05l-4.844 5.056z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureDistance);
export default __webpack_public_path__ + "static/media/measure-distance.21f87a1828b68af1abf1866a601b5b1d.svg";
export { ForwardRef as ReactComponent };